// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"TrustSignal_imgWrapper__gMd8m"};